import { BackLink, Breadcrumbs } from 'components/Shared';
import { useStackableBreadcrumbs, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import { useBrowser } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useActiveContext } from '../Context/ActiveContext';
import { ProductJourneyPages } from '../pages';
import SiteOverviewSlideContent from './SiteOverviewSlideContent';
const BreadcrumbsContainer = styled.div `
  ${({ showAbsolute }) => showAbsolute
    ? `
    position: absolute;
    top: 10px;
  `
    : `
  padding-top: 10px;
  `}
`;
const ScrollContainer = styled.div `
  z-index: 1;
  position: relative;
  height: 100%;
  overflow: auto;
  /* Workaround to fix parents container min-height requirement which overflows the container and hides part of the scrollbar */
  padding-bottom: 30px;

  ${({ isMobile }) => isMobile &&
    `
    min-height: 200px;
    height: calc(100vh - 32px);
  `}
`;
/**
 * For now this SiteOverviewSlide available only for farm cluster sites
 */
const DesktopSiteOverviewSlide = ({ chainStepActivity, isIntegration = false, }) => {
    const breadcrumbs = useStackableBreadcrumbs();
    const { deactivateActiveContent } = useStackableContent();
    const { activeSiteId, hasSelectedStepActivityOtherIngredients, activeStepIndex, isSelectedActivityTraceable, isSelectedStepTraceable, onActiveSiteChange, } = useActiveContext();
    const { isMobile } = useBrowser();
    const { t } = useTranslation();
    const scrollRef = useRef();
    const itemsRef = useRef({});
    const [scrollDisabled, setScrollDisabled] = useState(false);
    const handleItemClicked = (id) => {
        onActiveSiteChange(id === activeSiteId ? undefined : id);
        setScrollDisabled(true);
        setTimeout(() => setScrollDisabled(false), 250);
    };
    useEffect(() => {
        setTimeout(() => {
            if (scrollDisabled ||
                !itemsRef.current ||
                !activeSiteId ||
                !itemsRef.current[activeSiteId])
                return;
            setTimeout(() => {
                var _a;
                if (!scrollRef.current)
                    return;
                const elOffsetTop = ((_a = itemsRef.current[activeSiteId]) === null || _a === void 0 ? void 0 : _a.offsetTop) || 0;
                const top = isMobile ? elOffsetTop - 48 : elOffsetTop - 16;
                scrollRef.current.scrollTo({
                    top,
                    behavior: 'smooth',
                });
            }, 
            // Big delay for mobile, cause a new page first needs to open and the map then zooms in on the marker
            isMobile ? 2000 : 250);
        });
    }, [activeSiteId]);
    return (React.createElement(ScrollContainer, { ref: scrollRef, isMobile: isMobile },
        React.createElement(BackLink, { label: activeStepIndex === 0 ? t('back-to-origin') : t('back-button'), action: deactivateActiveContent }),
        React.createElement(BreadcrumbsContainer, { showAbsolute: isMobile && !isIntegration },
            React.createElement(Breadcrumbs, { config: breadcrumbs, backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } })),
        React.createElement(SiteOverviewSlideContent, { hasOtherIngredients: hasSelectedStepActivityOtherIngredients, itemsRef: itemsRef, isSelectedActivityTraceable: isSelectedActivityTraceable, isSelectedStepTraceable: isSelectedStepTraceable, activeSiteId: activeSiteId, chainStepActivity: chainStepActivity, onItemClick: handleItemClicked })));
};
export default DesktopSiteOverviewSlide;
